// Phase 15 M1 — Route wrapper that gates a child element on an access token.
//
// Anonymous users are redirected to /login with the current path captured as
// `?next=` so post-login redirect lands them where they originally clicked.
//
// We deliberately read the token directly from the store snapshot rather than
// through the React hook: this wrapper is rendered as a route element by
// react-router, so it MUST be a normal React component but the snapshot read
// is synchronous and the subscribe loop is cheap.

import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from './useAuth';

interface ProtectedRouteProps {
  children: JSX.Element;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps): JSX.Element {
  const { accessToken } = useAuth();
  const location = useLocation();

  if (!accessToken) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return children;
}
